import { useLocale } from "@bounce/i18n"

import { useCityPriceInterpolations } from "../hooks/useCityPriceInterpolations"
import { useInterpolations } from "../hooks/useInterpolations"
import { useSEO } from "../hooks/useSEO"
import {
  LogoStructuredData,
  ProductReviewStructuredData,
  WebsiteStructuredData,
} from "@/components/Generic/StructuredData/StructuredData"
import type { AggregateRating } from "@/libs/bounce/aggregateRating"
import type { CityData } from "@/libs/bounce/cities"
import { useCityUrl } from "@/libs/router"

import defaultImage from "@/assets/img/default_hero_3.png"

export type StructuredDataProps = {
  city: CityData
  aggregateRating: AggregateRating
}

export const StructuredData = ({ city, aggregateRating }: StructuredDataProps) => {
  const { locale } = useLocale()
  const interpolations = useInterpolations({ city })
  const { priceAmountForStructuredData } = useCityPriceInterpolations(city)
  const { metaTitle, metaDescription } = useSEO({ city, interpolations })
  const { absolutePath } = useCityUrl({ city })
  const { image } = city

  return (
    <>
      <WebsiteStructuredData alternateName={metaTitle} language={locale} />
      <LogoStructuredData />
      <ProductReviewStructuredData
        name={metaTitle}
        description={metaDescription}
        image={image ?? defaultImage.src}
        url={absolutePath}
        ratingValue={aggregateRating.rating}
        reviewCount={aggregateRating.count}
        lowestPrice={priceAmountForStructuredData}
        currency={interpolations.PRICE_CURRENCY}
      />
    </>
  )
}
